import React, { createContext, useContext, useMemo } from "react";
import useMobileDetect from "../hooks/useMobileDetect";

type MobileDetectContextType = { isMobileOnly: boolean };
const MobileDetectContext = createContext<MobileDetectContextType | undefined>(
  undefined
);

export const MobileDetectProvider = ({
  children,
  initialIsMobile,
}: {
  children: React.ReactNode;
  initialIsMobile?: boolean;
}) => {
  const isMobileOnly = useMobileDetect(initialIsMobile);
  const value = useMemo(() => ({ isMobileOnly }), [isMobileOnly]);
  return (
    <MobileDetectContext.Provider value={value}>
      {children}
    </MobileDetectContext.Provider>
  );
};

export const useMobileDetectContext = () => {
  const ctx = useContext(MobileDetectContext);
  if (!ctx)
    throw new Error(
      "useMobileDetectContext must be used inside MobileDetectProvider"
    );
  return ctx;
};
